import { Injectable } from '@angular/core';
import { Types } from 'shared-lib';
import { IDatabase } from '../../types/database.interface';
import { addRxPlugin, createRxDatabase, RxCollection, RxDatabase } from 'rxdb';
import { isDevMode } from '@angular/core';
import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
import { v4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class LibRXDBDatabaseService implements IDatabase {
  db!: RxDatabase;
  collections?: {
    image_cache: RxCollection;
  };

  constructor() {
    // this.createDb().then();
  }

  async initDb() {
    if (isDevMode()) {
      const module = await import('rxdb/plugins/dev-mode');
      addRxPlugin(module.RxDBDevModePlugin);
    }

    if (this.db) {
      return;
    }
    try {
      this.db = await createRxDatabase({
        name: 'tialtonivel_form-to-report_lib',
        storage: getRxStorageDexie(),
      });
      const fileCacheSchema = {
        version: 0,
        primaryKey: 'uuid',
        type: 'object',
        properties: {
          uuid: {
            type: 'string',
            maxLength: 100,
          },
          id: {
            type: 'number',
          },
          name: {
            type: 'string',
          },
          originalname: {
            type: 'string',
          },
          mimetype: {
            type: 'string',
          },
          size: {
            type: 'number',
          },
          base64: {
            type: 'string',
          },
          timestamp: {
            type: 'string',
            format: 'date-time',
          },
        },
        required: ['id', 'originalname', 'base64', 'size', 'timestamp'],
      };
      this.collections = await this.db.addCollections({
        image_cache: {
          schema: fileCacheSchema,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
  remove<T, R>(table: T, id: Types.TChoice | undefined) {
    throw new Error('Method not implemented.');
  }

  async readAll<T, R>(table: T): Promise<R[]> {
    //@ts-ignore
    return await this.collections?.[table]?.toArray();
  }

  async readOne<T, R>(
    table: T,
    id: Types.TChoice | undefined
  ): Promise<R | undefined> {
    if (!id || !['number', 'string'].includes(typeof id)) {
      return undefined;
    }
    //@ts-ignore
    const result = await this.collections?.[table]
      ?.find({
        selector: {
          id: {
            $eq: id,
          },
        },
      })
      .exec();
    if (!result || result.length != 1) {
      return undefined;
    }
    return result.at(0);
  }

  async create<T, R>(table: T, entity: R) {
    //@ts-ignore
    return await this.collections?.[table].insert({
      ...entity,
      uuid: v4(),
      timestamp: new Date().toISOString(),
    });
  }

  async update<T, R>(table: T, entity: R) {
    //@ts-ignore
    return await this.collections?.[table]?.add(entity);
  }
}
